<template>
  <div>
    <el-dialog
      :title="$t('collectionCenter.generate') + 'MDFE'"
      :visible.sync="showAddMDFEWindow"
      width="80%"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      :modal-append-to-body="true"
      top="5%"
      @close="closeWindow"
    >
      <div>
        <div v-if="step === 1">
          <el-tabs v-model="activeName" type="border-card">
            <el-tab-pane :label="$t('mdfeTranslate.ChooseVTag')" name="tag">
              <div style="display: flex">
                <div style="width: 300px;">
                  <div style="margin-bottom: 5px;">{{ $t('mdfeTranslate.Queue') }}：</div>
                  <div style="margin-bottom: 5px;">
                    <el-button
                      size="small" type="primary" style="width: 100%;"
                      @click="addTag"
                    >{{ $t('mdfeTranslate.AddVTagToTheQueue') }}</el-button>
                  </div>
                  <div>
                    <el-button
                      size="small" type="danger" style="width: 100%;"
                      @click="deleteAllTag"
                    >{{ $t('mdfeTranslate.DeleteAll') }}</el-button>
                  </div>
                </div>
                <div style="flex: 1;">
                  <div style="margin: 0 10px 5px 10px;">{{ $t('mdfeTranslate.SelectedVTags') }}
                    <span style="float: right">{{ $t('mdfeTranslate.TotalNumberOfPackages') }}：{{ selectedTagForm.vtagNum }}</span>
                  </div>
                  <div style="padding: 10px;border: 1px solid #ddd;border-radius: 3px;margin: 0 10px;min-height: 200px;max-height: 400px;overflow-y: auto">
                    <div
                      v-for="(item, index) in selectedTagForm.vtag"
                      :key="item.vtag"
                      style="
                        padding: 5px 10px;
                        border: 1px solid #ddd;
                        border-radius: 3px;
                        margin-bottom: 10px;
                      "
                      @click.stop="checkVtagDetail(item)"
                    >
                      <div style="display: flex;align-items: center">
                        <div style="flex: 1">{{ item.vtag }}</div>
                        <div>
                          <el-button
                            size="small" type="danger" icon="el-icon-delete"
                            circle
                            @click.stop="delTag(index)"
                          />
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </el-tab-pane>
          </el-tabs>
        </div>
        <div v-if="step === 2">
          <el-form ref="step2" :model="selectedTagForm" label-position="top">
            <el-form-item
              :label="$t('mdfeTranslate.ChooseCompany')"
              prop="companyId"
              :rules="{ required: true, message: $t('placeOrder.pleaseChoose'), trigger: ['blur','change'] }"
            >
              <el-select
                v-model="selectedTagForm.companyId"
                :placeholder="$t('placeOrder.pleaseChoose')"
                class="formTable"
                clearable
                filterable
                remote
                reserve-keyword
                :remote-method="getCompanyList"
                style="width: 100%"
                @visible-change="handleCompanyList"
              >
                <el-option
                  v-for="item in companyList"
                  :key="item.id"
                  :label="item.fantasyName ? item.fantasyName : item.name"
                  :value="item.id"
                />
              </el-select>
            </el-form-item>
            <div style="font-weight: bold;margin-bottom: 10px;">{{ $t('mdfeTranslate.RouteInformation') }}</div>
            <el-row :gutter="10">
              <el-col :span="8">
                <div style="display: flex;padding: 10px;background: #409eff;border-radius: 3px;color:#fff;align-items: center;margin-bottom: 10px;">
                  <div style="flex: 1">{{ $t('mdfeTranslate.source') }}</div>
                  <div style="flex: 1;text-align: center">{{ $t('mdfeTranslate.quantity') }}：{{ selectedTagForm.startUF.length }}</div>
                  <div style="flex: 1;text-align: right">
                    <el-button
                      type="text" size="mini" style="padding: 3px"
                      @click="addStartUF"
                    >
                      <i class="el-icon-circle-plus-outline" style="color:#fff;font-size: 20px" />
                    </el-button>
                  </div>
                </div>
                <div
                  v-for="(item, index) in selectedTagForm.startUF"
                  :key="index" style="padding: 10px; border: 1px solid #eee; border-radius: 3px"
                >
                  <div>
                    <span style="font-weight: bold">{{ index + 1 }} {{ $t('mdfeTranslate.source') }}</span>
                    <el-button
                      :disabled="selectedTagForm.startUF.length === 1"
                      type="text"
                      style="float:right;"
                      @click="deletestartUF(index)"
                    >
                      <i class="el-icon-delete" style="font-size: 20px;color: #f56c6c;" />
                    </el-button>
                  </div>
                  <el-form-item
                    :label="$t('collectionCenter.zipCode')"
                    :prop="'startUF.' + index + '.cep'"
                    :rules="{ required: true, validator: checkPostcode, type: 1, index: index, trigger: ['change'] }"
                  >
                    <el-input
                      v-model="item.cep"
                      :placeholder="$t('placeOrder.pleaseInput')"
                      clearable
                      style="width: 100%"
                      :maxlength="8"
                      show-word-limit
                    />
                  </el-form-item>
                  <div style="padding: 10px; border: 1px solid #eee; border-radius: 3px">
                    UF：{{ item.uf }}
                    <div>{{ $t('mdfeTranslate.cityCode') }}：{{ item.cityCode }}</div>
                    <div>{{ $t('mdfeTranslate.CityName') }}：{{ item.cityName }}</div>
                  </div>
                </div>
              </el-col>
              <el-col :span="8">
                <div style="display: flex;padding: 10px;background: #409eff;border-radius: 3px;color:#fff;align-items: center;margin-bottom: 10px;">
                  <div style="flex: 1">{{ $t('mdfeTranslate.RoutePoint') }}</div>
                  <div style="flex: 1;text-align: center">{{ $t('mdfeTranslate.quantity') }}：{{ selectedTagForm.throughUF.length }}</div>
                  <div style="flex: 1;text-align: right">
                    <el-button
                      type="text" size="mini" style="padding: 3px"
                      @click="addthroughUF"
                    >
                      <i class="el-icon-circle-plus-outline" style="color:#fff;font-size: 20px" />
                    </el-button>
                  </div>
                </div>
                <div
                  v-for="(item, index) in selectedTagForm.throughUF"
                  :key="index" style="padding: 10px; border: 1px solid #eee; border-radius: 3px"
                >
                  <div>
                    <span style="font-weight: bold">{{ index + 1 }} {{ $t('mdfeTranslate.way') }}</span>
                    <el-button
                      type="text"
                      style="float:right;"
                      @click="deletethroughUF(index)"
                    >
                      <i class="el-icon-delete" style="font-size: 20px;color: #f56c6c;" />
                    </el-button>
                  </div>
                  <el-form-item
                    :label="$t('mdfeTranslate.way')"
                    :prop="'throughUF.' + index + '.uf'"
                    :rules="{ required: true, message: $t('placeOrder.pleaseInput'), trigger: ['blur','change'] }"
                  >
                    <el-select
                      v-model="item.uf"
                      :placeholder="$t('placeOrder.pleaseChoose')"
                      clearable
                      filterable
                      style="width: 100%"
                    >
                      <el-option
                        v-for="list in senderStateList"
                        :key="list.stateCode"
                        :label="list.stateNameZh + '（' + list.stateNamePu + '）'"
                        :value="list.stateCode"
                      />
                    </el-select>
                  </el-form-item>
                </div>
              </el-col>
              <el-col :span="8">
                <div style="display: flex;padding: 10px;background: #409eff;border-radius: 3px;color:#fff;align-items: center;margin-bottom: 10px;">
                  <div style="flex: 1">{{ $t('mdfeTranslate.destination') }}</div>
                  <div style="flex: 1;text-align: center">{{ $t('mdfeTranslate.quantity') }}：{{ selectedTagForm.endUF.length }}</div>
                  <div style="flex: 1;text-align: right">
                    <el-button
                      type="text" size="mini" style="padding: 3px"
                      @click="addendUF"
                    >
                      <i class="el-icon-circle-plus-outline" style="color:#fff;font-size: 20px" />
                    </el-button>
                  </div>
                </div>
                <div
                  v-for="(item, index) in selectedTagForm.endUF"
                  :key="index" style="padding: 10px; border: 1px solid #eee; border-radius: 3px"
                >
                  <div>
                    <span style="font-weight: bold">{{ index + 1 }} {{ $t('mdfeTranslate.destination') }}</span>
                    <el-button
                      :disabled="selectedTagForm.endUF.length === 1"
                      type="text"
                      style="float:right;"
                      @click="deleteendUF(index)"
                    >
                      <i class="el-icon-delete" style="font-size: 20px;color: #f56c6c;" />
                    </el-button>
                  </div>
                  <el-form-item
                    :label="$t('collectionCenter.zipCode')"
                    :prop="'endUF.' + index + '.cep'"
                    :rules="{ required: true, validator: checkPostcode, type: 2, index: index, trigger: ['change'] }"
                  >
                    <el-input
                      v-model="item.cep"
                      :placeholder="$t('placeOrder.pleaseInput')"
                      clearable
                      :maxlength="8"
                      show-word-limit
                      style="width: 100%"
                    />
                  </el-form-item>
                  <div style="padding: 10px; border: 1px solid #eee; border-radius: 3px">
                    UF：{{ item.uf }}
                    <div>{{ $t('mdfeTranslate.cityCode') }}：{{ item.cityCode }}</div>
                    <div>{{ $t('mdfeTranslate.CityName') }}：{{ item.cityName }}</div>
                  </div>
                </div>
              </el-col>
            </el-row>
          </el-form>
        </div>
        <div v-if="step === 3">
          <div style="font-weight: bold; margin-bottom: 10px;">{{ $t('mdfeTranslate.DriverAndVehicle') }}</div>
          <el-form ref="step3" :model="selectedTagForm" label-position="top">
            <el-row :gutter="10">
              <el-col :span="12">
                <el-form-item
                  :label="$t('collectionCenter.driver1')"
                  prop="selectedDriver"
                  :rules="{
                    required: true,
                    message: $t('GlobalSetObj.pleaseChoose'),
                    trigger: ['blur', 'change']
                  }"
                >
                  <el-select
                    v-model="selectedTagForm.selectedDriver"
                    :placeholder="$t('placeOrder.pleaseChoose')"
                    class="formTable"
                    clearable
                    filterable
                    remote
                    reserve-keyword
                    :remote-method="getDriverInfo"
                    style="width: 100%"
                    @visible-change="handleDriverInfo"
                  >
                    <el-option
                      v-for="item in driverList"
                      :key="item.id"
                      :label="item.driverName"
                      :value="item.id"
                    />
                  </el-select>
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item
                  :label="$t('collectionCenter.licensePlateNumber')"
                  prop="vehiclePlate"
                  :rules="{
                    required: selectedTagForm.selectedDriverItem.length === 0,
                    message: $t('collectionCenter.notNull'),
                    trigger: ['change']
                  }"
                >
                  <!--                  <el-select-->
                  <!--                    v-model="selectedTagForm.vehiclePlate"-->
                  <!--                    :placeholder="$t('placeOrder.pleaseChoose')"-->
                  <!--                    class="formTable"-->
                  <!--                    clearable-->
                  <!--                    filterable-->
                  <!--                    remote-->
                  <!--                    reserve-keyword-->
                  <!--                    :remote-method="getCarInfoList"-->
                  <!--                    style="width: 100%"-->
                  <!--                    @visible-change="handleCarInfoList"-->
                  <!--                  >-->
                  <!--                    <el-option-->
                  <!--                      v-for="item in vehicleList"-->
                  <!--                      :key="item.id"-->
                  <!--                      :label="item.driverName"-->
                  <!--                      :value="item.id"-->
                  <!--                    />-->
                  <!--                  </el-select>-->
                  <el-input
                    v-model="selectedTagForm.vehiclePlate"
                    :placeholder="$t('placeOrder.pleaseInput')"
                    clearable
                    style="width: 100%"
                  />
                </el-form-item>
              </el-col>
            </el-row>
          </el-form>
          <div style="display: flex">
            <div style="flex: 1; padding-right: 5px">
              <el-button
                size="small"
                type="primary"
                style="width: 100%"
                @click="addDriver"
              >
                {{ $t('mdfeTranslate.ChooseVehicleAndDriver') }}
              </el-button>
            </div>
            <div style="flex: 1;padding-left: 5px">
              <el-button
                size="small" type="danger" style="width: 100%"
                @click="deleteAllDriver"
              >
                {{ $t('mdfeTranslate.DeleteAll') }}
              </el-button>
            </div>
          </div>
          <div style="margin-top: 10px">
            <div style="font-weight: bold; margin-bottom: 10px;">{{ $t('mdfeTranslate.SelectedDriver') }}</div>
          </div>
          <div v-if="selectedTagForm.selectedDriverItem.length > 0" :key="selectedTagFormKey" style="display: flex;">
            <div style="flex: 1;padding: 10px;border: 1px solid #ccc;border-radius: 5px;margin-right: 10px;height: 500px;overflow-y: auto">
              <div
                v-for="(item, index) in selectedTagForm.selectedDriverItem"
                :key="index"
                style="margin-bottom: 10px;"
              >
                <div v-if="index === 0" style="color: black;font-weight: bold;height: 50px;">
                  {{ item.name }}
                </div>
                <div style="display: flex;border: 1px solid #ccc;border-radius: 5px;padding: 6px;">
                  <div style="flex: 1;">
                    <!--姓名-->
                    <div>{{ $t('collectionCenter.compellation') }}: {{ item.name }}</div>
                    <!--税号-->
                    <div>{{ $t('mdfeTranslate.document') }}(CPF/CNPJ): {{ item.cpf }}</div>
                  </div>
                  <div style="width: 50px">
                    <el-button
                      type="danger"
                      size="mini"
                      @click="deleteDriver(index)"
                    >
                      <i class="el-icon-delete" />
                    </el-button>
                  </div>
                </div>
              </div>
            </div>
            <div style="flex: 1;padding: 10px;border: 1px solid #ccc;border-radius: 5px;margin-left: 10px">
              <div>
                <div style="color: black;font-weight: bold;height: 50px;">{{ vehicleInformation.licensePlateNumber }}</div>
                <!--车牌-->
                <div>{{ $t('GlobalSetObj.licensePlateNumber') }}: {{ vehicleInformation.licensePlateNumber }}</div>
                <!--卡车租赁-->
                <div>{{ $t('mdfeTranslate.TrailerRENAVAM') }}: {{ vehicleInformation.TrailerRENAVAM }}</div>
                <!--卡车皮重-->
                <div>{{ $t('mdfeTranslate.TrailerTare') }}: {{ vehicleInformation.TrailerTare }}</div>
                <!--卡车容量-->
                <div>{{ $t('mdfeTranslate.TrailerCapacity') }}: {{ vehicleInformation.TrailerCapacity }}</div>
                <!--卡车RNTRC-->
                <div>{{ $t('mdfeTranslate.TrailerRNTRC') }}: {{ vehicleInformation.TrailerRNTRC }}</div>
                <!--货车证件-->
                <div>{{ $t('mdfeTranslate.TruckDocuments') }}: {{ vehicleInformation.TrailerDocuments }}</div>
                <div>IE: {{ vehicleInformation.ie }}</div>
                <!--州-->
                <div>{{ $t('mdfeTranslate.State') }}: {{ vehicleInformation.State }}</div>
                <!--车轮类型-->
                <div>{{ $t('mdfeTranslate.WheelKind') }}: {{ vehicleInformation.WheelKind }}</div>
                <!--车辆类型-->
                <div>{{ $t('mdfeTranslate.VehicleType') }}: {{ vehicleInformation.vehicleType }}</div>
              </div>
            </div>
          </div>
        </div>
        <div v-if="step === 4">
          <el-form ref="step4" :model="selectedTagForm" label-position="top">
            <el-row :gutter="10">
              <el-col :span="24">
                <el-form-item
                  :label="$t('mdfeTranslate.TrailerPlateNumber')"
                  prop="veicReboque"
                  class="appendTag"
                >
                  <el-input v-model.trim="selectedTagForm.veicReboque" :placeholder="$t('placeOrder.pleaseInput')">
                    <template slot="append">
                      <i class="el-icon-circle-plus-outline" style="font-size: 26px" @click="addVeicReboque" />
                    </template>
                  </el-input>

                </el-form-item>
              </el-col>
            </el-row>
          </el-form>
          <div style="margin-top: 10px">
            <div style="font-weight: bold; margin-bottom: 10px;">{{ $t('mdfeTranslate.SelectedVehicles') }}</div>
          </div>
          <div class="driver-container">
            <div
              v-for="(item, index) in veicReboqueList"
              :key="index"
              class="driver-item"
              :class="getColSpan(index, veicReboqueList.length)"
            >
              <div style="color: black;font-weight: bold;height: 50px;">{{ item.licensePlateNumber }}
                <div style="float: right">
                  <el-button
                    type="danger"
                    size="small"
                    @click="deleteVeicReboque(index)"
                  >
                    <i class="el-icon-delete" />
                  </el-button>
                </div>
              </div>
              <div>
                <!--车辆所属公司-->
                <div>{{ $t('mdfeTranslate.Proprietário') }}: {{ item.providerName }}</div>
                <!--车牌-->
                <div>{{ $t('GlobalSetObj.licensePlateNumber') }}: {{ item.licensePlateNumber }}</div>
                <!--税号-->
                <div>{{ $t('mdfeTranslate.document') }}(CPF/CNPJ): {{ item.driverDocument }}</div>
                <!--卡车租赁-->
                <div>{{ $t('mdfeTranslate.TrailerRENAVAM') }}: {{ item.TrailerRENAVAM }}</div>
                <!--卡车皮重-->
                <div>{{ $t('mdfeTranslate.TrailerTare') }}: {{ item.TrailerTare }}</div>
                <!--卡车容量-->
                <div>{{ $t('mdfeTranslate.TrailerCapacity') }}: {{ item.TrailerCapacity }}</div>
                <!--卡车RNTRC-->
                <div>{{ $t('mdfeTranslate.TrailerRNTRC') }}: {{ item.TrailerRNTRC }}</div>
                <div>IE: {{ item.ie }}</div>
                <!--州-->
                <div>{{ $t('mdfeTranslate.State') }}: {{ item.State }}</div>
                <!--车辆类型-->
                <div>{{ $t('mdfeTranslate.VehicleType') }}: {{ item.vehicleType }}</div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div style="margin-top: 10px;text-align: right">
        <el-button
          v-if="step !== 1" size="small" type="primary"
          style="float: left;"
          @click="previousStep"
        >{{ $t('mdfeTranslate.Previous') }}</el-button>
        <el-button
          v-if="step !== 4" size="small" type="primary"
          @click="nextStep"
        >{{ $t('mdfeTranslate.Next') }}</el-button>
        <el-button
          v-if="step === 4" size="small" type="primary"
          @click="createOrder"
        >{{ $t('collectionCenter.submit') }}</el-button>
      </div>
    </el-dialog>
    <!--添加车签号-->
    <el-dialog
      :title="$t('mdfeTranslate.VTagsQueue')"
      :visible.sync="showAddTagWindow"
      width="60%"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      :modal-append-to-body="true"
      top="5%"
    >
      <div>
        <el-form :model="selectTag" label-position="top">
          <el-form-item :label="$t('mdfeTranslate.SelectTheVTagType')">
            <el-radio-group v-model="selectTag.vtagType" :disabled="selectedTagForm.vtag.length > 0">
              <el-radio label="COLLECT">{{ $t('mdfeTranslate.Coleta') }}</el-radio><!--揽收-->
              <el-radio label="DELIVERY">{{ $t('mdfeTranslate.Entrega') }}</el-radio><!--派送-->
            </el-radio-group>
          </el-form-item>
          <el-form-item :label="$t('mdfeTranslate.ListOfVTags')" class="appendTag">
            <el-input v-model.trim="tag" :placeholder="$t('placeOrder.pleaseInput')">
              <template slot="append">
                <i class="el-icon-circle-plus-outline" style="font-size: 26px" @click="appendTag" />
              </template>
            </el-input>
            <div style="margin-top: 10px;">
              <div>{{ $t('mdfeTranslate.SelectedVTag') }}</div>
              <div style="border: 1px solid #ddd;border-radius: 3px;height: 300px; padding: 10px; overflow-y: auto;">
                <div
                  v-for="(item, index) in selectTag.vtag"
                  :key="item.vtag"
                  style="
                    padding: 5px 10px;
                    border: 1px solid #ddd;
                    border-radius: 3px;
                    margin-bottom: 10px;
                  "
                >
                  <div style="display: flex;align-items: center">
                    <div style="flex: 1">{{ item.vtag }}</div>
                    <div>
                      <el-button
                        size="small" type="danger" icon="el-icon-delete"
                        circle
                        @click="removeTag(index)"
                      />
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </el-form-item>
        </el-form>
      </div>
      <div slot="footer" class="dialog-footer">
        <el-button
          size="small" type="primary" :disabled="selectTag.vtag.length === 0"
          @click="confirmAppend"
        >{{ $t('collectionCenter.confirm') }}</el-button>
        <el-button size="small" @click="showAddTagWindow = false">{{ $t('collectionCenter.cancel') }}</el-button>
      </div>
    </el-dialog>
    <!--查看车签信息-->
    <el-dialog
      :title="vtagDetail.vtag"
      :visible.sync="showVtagDetail"
      width="60%"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      :modal-append-to-body="true"
      top="5%"
    >
      <div style="display: flex;border: 1px solid #ddd;border-radius: 5px">
        <div style="flex: 1;padding: 10px;display: flex;flex-direction: column; justify-content: center;">
          <div>{{ $t('mdfeTranslate.QuantityOfPackages') }}：{{ vtagDetail.validPackage.length }}</div>
          <div>{{ $t('mdfeTranslate.FreteTotal') }}：
            <span v-if="$i18n.locale !== 'zh'">R$ {{ formatNumber(vtagDetail.totalCost) }}</span>
            <span v-else>{{ vtagDetail.totalCost }} 雷亚尔</span>
          </div>
          <div>{{ $t('mdfeTranslate.TotalValue') }}：
            <span v-if="$i18n.locale !== 'zh'">R$ {{ formatNumber(vtagDetail.totalPrice) }}</span>
            <span v-else>{{ vtagDetail.totalPrice }} 雷亚尔</span>
          </div>
          <div>{{ $t('mdfeTranslate.TotalWeight') }}：{{ vtagDetail.totalWeight }} KG</div>
        </div>
        <div style="flex: 1;padding: 10px">
          <div>{{ $t('mdfeTranslate.Packages') }}</div>
          <div style="border: 1px solid #ddd;border-radius: 5px;padding: 10px;height: 500px;overflow-y: auto">
            <div v-for="(item, index) in vtagDetail.validPackage" :key="index" style="padding: 3px 5px;background:#ededed;border-radius: 3px;margin: 5px 0">{{ item }}</div>
          </div>

        </div>
      </div>
      <div slot="footer" class="dialog-footer">
        <el-button size="small" @click="showVtagDetail = false">{{ $t('collectionCenter.close') }}</el-button>
      </div>
    </el-dialog>
  </div>
</template>
<script>
import {
  checkCarSign,
  getCarInfoByPlateNumber,
  getCompanyOptions,
  getDriverPage,
  createMdfe,
  getAddressByZipCode
  // getCarList
} from '@/api/invoiceCenter';
import { formatNumber } from '@/utils/tools';
export default {
  props: {
    showAddMDFEWindow: {
      type: Boolean,
      default: false
    },
    senderStateList: {
      type: Array,
      default: () => []
    }
  },
  data() {
    // 邮编
    const checkPostcode = async(rule, value, callback) => {
      const reg = /^\d{8}$/;
      if (!value) {
        return callback(new Error(this.$t('collectionCenter.notNull'))); // 不能为空
      } else {
        if (!reg.test(value)) {
          return callback(new Error(this.$t('mdfeTranslate.PostalCodeFormatIsIncorrect'))); // 邮编格式不正确
        } else {
          const param = {
            cep: value
          };
          const { data } = await getAddressByZipCode(param);
          if (rule.type === 1) {
            this.selectedTagForm.startUF[rule.index].uf = data.uf;
            this.selectedTagForm.startUF[rule.index].cityCode = data.ibge;
            this.selectedTagForm.startUF[rule.index].cityName = data.localidade;
          } else {
            this.selectedTagForm.endUF[rule.index].uf = data.uf;
            this.selectedTagForm.endUF[rule.index].cityCode = data.ibge;
            this.selectedTagForm.endUF[rule.index].cityName = data.localidade;
          }
          if (!data.uf) {
            return callback(new Error(this.$t('mdfeTranslate.TheAddressCorrespondingToThePostalCodeDoesNotExist'))); // '邮编对应的地址不存在'
          } else {
            return callback();
          }
        }
      }
    };
    return {
      step: 1,
      activeName: 'tag',
      selectedTagForm: {
        vtagType: '',
        vtag: [],
        companyId: '',
        startUF: [
          {
            uf: '', // 起点州
            cep: '', // 起点邮编
            cityCode: '', // 起点城市code
            cityName: '' // 起点城市
          }
        ],
        throughUF: [],
        endUF: [
          {
            uf: '', // 终点州
            cep: '', // 终点邮编
            cityCode: '', // 终点城市code
            cityName: '' // 终点城市
          }
        ],
        driver: [],
        selectedDriver: [],
        vehiclePlate: '',
        veicReboque: [],
        selectedDriverItem: [],
        vtagNum: 0
      },
      tag: '',
      selectTag: {
        vtagType: 'COLLECT',
        vtag: []
      },
      showAddTagWindow: false,
      companyList: [],
      checkPostcode,
      driverList: [],
      veicReboqueList: [],
      vtagDetail: {
        vtag: '',
        invalidPackage: [],
        totalCost: 0.00,
        totalPrice: 0.00,
        totalWeight: 0.00,
        validPackage: []
      },
      showVtagDetail: false,
      selectedTagFormKey: new Date().getTime(),
      vehicleInformation: {
        driverDocument: '',
        licensePlateNumber: '',
        TrailerRENAVAM: '',
        TrailerTare: '',
        TrailerCapacity: '',
        TrailerRNTRC: '',
        TrailerDocuments: '',
        ie: '',
        State: '',
        WheelKind: '',
        vehicleType: ''
      },
      formatNumber,
      vehicleList: []
    };
  },
  watch: {
    showAddMDFEWindow(newVal) {
      if (newVal) {
        this.resetData();
      }
    }
  },
  methods: {
    // 获取车牌信息
    // getCarInfoList(plate = null) {
    //   const param = {
    //     skip: 0,
    //     take: 10,
    //     plate,
    //     active: 1
    //   };
    //   getCarList(param, false).then(res => {
    //     this.vehicleList = res.data;
    //   });
    // },
    // handleCarInfoList(val) {
    //   if (val) {
    //     this.getCarInfoList();
    //   }
    // },
    // 删除已选中的司机
    deleteDriver(index) {
      this.selectedTagForm.selectedDriverItem.splice(index, 1);
    },
    // 删除全部司机
    deleteAllDriver() {
      this.selectedTagForm.selectedDriverItem = [];
    },
    // 添加司机
    addDriver() {
      this.$refs.step3.validate(async valid => {
        if (valid) {
          let isAdd = true;
          if (this.selectedTagForm.selectedDriverItem && this.selectedTagForm.selectedDriverItem.length > 0) {
            this.selectedTagForm.selectedDriverItem.map(item => {
              if (item.id === this.selectedTagForm.selectedDriver) {
                isAdd = false;
              }
            });
          }
          if (!isAdd) {
            this.$message.error(this.$t('mdfeTranslate.SelectedDriverCannotBeTheSame'));
            return;
          }
          let isPlateNumber = true;
          if (this.selectedTagForm.vehiclePlate) {
            await getCarInfoByPlateNumber(this.selectedTagForm.vehiclePlate).then(res => {
              console.log(res, '====res===');
              if (res.code === 200) {
                const driverInfo = res.data;
                this.vehicleInformation = {
                  driverDocument: driverInfo.vehicleOwnerCNPJ ? driverInfo.vehicleOwnerCNPJ : driverInfo.vehicleOwnerCPF,
                  licensePlateNumber: driverInfo.vehicleLicensePlate,
                  TrailerRENAVAM: driverInfo.vehicleDocumentation,
                  TrailerTare: driverInfo.vehicleTareWeight,
                  TrailerCapacity: driverInfo.vehicleCapacityKg,
                  TrailerRNTRC: driverInfo.vehicleRNTRC,
                  TrailerDocuments: driverInfo.vehicleDocumentation,
                  ie: driverInfo.ie,
                  State: driverInfo.vehicleState,
                  WheelKind: driverInfo.vehicleWheelsetType,
                  vehicleType: driverInfo.vehicleTypeOwnership
                };
              } else {
                isPlateNumber = false;
              }
            }).catch(err => {
              console.log(err, '====err===');
              isPlateNumber = false;
            });
          }
          console.log(isPlateNumber, '=isPlateNumber');
          if (isPlateNumber === false) {
            return;
          }
          const driver = this.driverList.filter(item => this.selectedTagForm.selectedDriver === item.id);
          const addDriver = {
            id: driver[0].id,
            name: driver[0].driverName,
            cpf: driver[0].driverDocument
          };
          this.selectedTagForm.selectedDriverItem.push(addDriver);
          this.selectedTagFormKey = new Date().getTime();
          this.selectedTagForm.vehiclePlate = null;
          this.selectedTagForm.selectedDriver = null;
          this.$nextTick(() => {
            this.$refs.step3.clearValidate();
          });
        }
      });
    },
    getColSpan(index, length) {
      // 如果只有一个元素，占满整行
      if (length === 1) {
        return 'full-width';
      }
      // 如果是最后一个元素且总数为奇数，则占满整行
      if (index === length - 1 && length % 2 === 1) {
        return 'full-width';
      }
      // 其他情况各占一半
      return 'half-width';
    },
    // 初始化数据
    resetData() {
      // 重置所有状态和表单数据
      this.step = 1;
      this.selectedTagForm = {
        vtagType: '',
        vtag: [],
        companyId: '',
        startUF: [
          {
            uf: '', // 起点州
            cep: '', // 起点邮编
            cityCode: '', // 起点城市code
            cityName: '' // 起点城市
          }
        ],
        throughUF: [],
        endUF: [
          {
            uf: '', // 终点州
            cep: '', // 终点邮编
            cityCode: '', // 终点城市code
            cityName: '' // 终点城市
          }
        ],
        driver: [],
        selectedDriver: [],
        vehiclePlate: '',
        veicReboque: [],
        selectedDriverItem: [],
        vtagNum: 0
      };
      this.tag = '';
      this.selectTag = {
        vtagType: 'COLLECT',
        vtag: []
      };
      this.veicReboqueList = [];
      this.vtagDetail = {
        vtag: '',
        invalidPackage: [],
        totalCost: 0.00,
        totalPrice: 0.00,
        totalWeight: 0.00,
        validPackage: []
      };
    },
    // 关闭生成MDFE弹窗
    closeWindow() {
      this.$emit('closeWindow');
    },
    // 提交生成MDFE
    createOrder() {
      const param = {
        vtagType: this.selectedTagForm.vtagType,
        vtag: this.selectedTagForm.vtag.map(item => {
          return item.vtag;
        }), // this.selectedTagForm.vtag,
        companyId: this.selectedTagForm.companyId,
        startUF: this.selectedTagForm.startUF,
        throughUF: this.selectedTagForm.throughUF,
        endUF: this.selectedTagForm.endUF,
        driver: [],
        vehiclePlate: this.vehicleInformation.licensePlateNumber,
        veicReboque: []
      };
      this.selectedTagForm.selectedDriverItem.map(item => {
        param.driver.push({
          name: item.name,
          cpf: item.cpf
        });
      });
      this.veicReboqueList.map(item => {
        param.veicReboque.push(item.licensePlateNumber);
      });
      console.log(param, '====param');
      createMdfe(param).then(res => {
        if (res.code === 200) {
          if (res.data.success) {
            this.$message.success(this.$t('GlobalSetObj.TheOperationSucceeded')); // '操作成功'
            this.$emit('closeWindow', true);
          } else {
            this.$message.error(res.data.failureReason || this.$t('mdfeTranslate.OperationFailed')); // 操作失败
          }
        }
      });
    },
    // 下一步
    nextStep() {
      if (this.step === 1) {
        if (this.selectedTagForm.vtag.length > 0) {
          this.step = 2;
        } else {
          this.$message.error(this.$t('mdfeTranslate.PleaseSelectALabel')); // '请选择标签'
        }
      } else if (this.step === 2) {
        this.$refs.step2.validate(valid => {
          if (valid) {
            const allStartUFEqual = this.selectedTagForm.startUF.every(
              (item, index, arr) => item.uf === arr[0].uf
            );
            if (!allStartUFEqual) {
              this.$message.error(this.$t('mdfeTranslate.StartingStateInconsistent')); // '起点州不一致'
              return;
            }
            const allEndUFEqual = this.selectedTagForm.endUF.every(
              (item, index, arr) => item.uf === arr[0].uf
            );
            if (!allEndUFEqual) {
              this.$message.error(this.$t('mdfeTranslate.DestinationStateInconsistent')); // '终点州不一致'
              return;
            }
            this.step = 3;
          }
        });
      } else if (this.step === 3) {
        if (this.selectedTagForm.selectedDriverItem.length > 0) {
          this.step = 4;
        } else {
          this.$message.error(this.$t('mdfeTranslate.PleaseAddDriverAndVehicle'));
        }
      }
    },
    // 上一步
    previousStep() {
      this.step -= 1;
    },
    // 删除拖车
    deleteVeicReboque(index) {
      this.veicReboqueList.splice(index, 1);
    },
    // 添加拖车
    addVeicReboque() {
      if (this.selectedTagForm.veicReboque) {
        getCarInfoByPlateNumber(this.selectedTagForm.veicReboque).then(res => {
          if (!res.data) {
            this.$message.error(this.$t('mdfeTranslate.PlateNumberDoesNotExist')); // '车牌号不存在'
          } else {
            let isAdd = true;
            this.veicReboqueList.map(item => {
              if (item.licensePlateNumber === this.selectedTagForm.veicReboque) {
                isAdd = false;
              }
            });
            if (!isAdd) {
              this.$message.error(this.$t('mdfeTranslate.PlateNumberCannotBeRepeated'));
              return;
            }
            const item = {
              providerName: res.data.providerName,
              driverDocument: res.data.vehicleOwnerCNPJ ? res.data.vehicleOwnerCNPJ : res.data.vehicleOwnerCPF,
              licensePlateNumber: res.data.vehicleLicensePlate,
              TrailerRENAVAM: res.data.vehicleDocumentation,
              TrailerTare: res.data.vehicleTareWeight,
              TrailerCapacity: res.data.vehicleCapacityKg,
              TrailerRNTRC: res.data.vehicleRNTRC,
              TrailerDocuments: res.data.vehicleDocumentation,
              ie: res.data.ie,
              State: res.data.vehicleState,
              WheelKind: res.data.vehicleWheelsetType,
              vehicleType: res.data.vehicleTypeOwnership
            };
            this.veicReboqueList.push(item);
            this.selectedTagForm.veicReboque = null;
          }
        });
      }
    },
    // 删除终点
    deleteendUF(index) {
      this.selectedTagForm.endUF.splice(index, 1);
    },
    // 添加终点
    addendUF() {
      this.selectedTagForm.endUF.push({
        uf: '', // 终点州
        cep: '', // 终点邮编
        cityCode: '', // 终点城市code
        cityName: '' // 终点城市
      });
    },
    // 删除途径站
    deletethroughUF(index) {
      this.selectedTagForm.throughUF.splice(index, 1);
    },
    // 添加途径站
    addthroughUF() {
      this.selectedTagForm.throughUF.push({
        uf: '' // 途径州
      });
    },
    // 删除起点
    deletestartUF(index) {
      this.selectedTagForm.startUF.splice(index, 1);
    },
    // 添加起点
    addStartUF() {
      this.selectedTagForm.startUF.push({
        uf: '', // 起点州
        cep: '', // 起点邮编
        cityCode: '', // 起点城市code
        cityName: '' // 起点城市
      });
    },
    // 获取公司选项
    getCompanyList(name = '') {
      const param = {
        pageNumber: 1,
        pageSize: 20,
        params: {
          name
        }
      };
      getCompanyOptions(param).then(res => {
        if (res.code === 200) {
          this.companyList = res.data.records;
        }
      });
    },
    handleCompanyList(val) {
      if (val) {
        this.getCompanyList();
      }
    },
    // 获取司机信息
    getDriverInfo(driverName = '') {
      const param = {
        pageNumber: 1,
        pageSize: 20,
        params: {
          driverName
        }
      };
      getDriverPage(param).then(res => {
        if (res.code === 200) {
          this.driverList = res.data.records;
        }
      });
    },
    handleDriverInfo(val) {
      if (val) {
        this.getDriverInfo();
      }
    },
    // 打开添加tag窗口
    addTag() {
      this.selectTag = {
        vtagType: this.selectedTagForm.vtagType ? this.selectedTagForm.vtagType : 'COLLECT',
        vtag: []
      };
      console.log(this.selectedTagForm.vtagType, '==selectedTagForm.vtagType');
      this.showAddTagWindow = true;
    },
    // 添加tag
    appendTag() {
      console.log(this.tag, '===this.tag');
      if (this.tag) {
        const param = {
          vtagType: this.selectTag.vtagType,
          vtag: [this.tag]
        };
        checkCarSign(param).then(res => {
          console.log(res, '===res');
          this.selectedTagForm.vtagType = this.selectTag.vtagType;
          this.selectedTagForm.vtagNum = 0;
          // 检查数组中是否已存在具有相同vtag的对象
          const exists = this.selectTag.vtag.some(item => item.vtag === res.data[0].vtag);

          // 如果不存在，则将新对象推入数组
          if (!exists) {
            this.selectTag.vtag.push(res.data[0]);
          } else {
            this.$message.error(this.$t('mdfeTranslate.CarrierSignatureRepeated'));
          }
        });
      } else {
        this.$message.warning(this.$t('mdfeTranslate.PleaseEnterTheCarSign'));
      }
      this.tag = '';
    },
    // 移除tag
    removeTag(index) {
      this.selectTag.vtag.splice(index, 1);
    },
    // 确定添加
    confirmAppend() {
      // 数组合并去重
      const mergeUniqueVTags = (array1, array2) => {
        const map = new Map();
        [...array1, ...array2].forEach(item => {
          const key = item.vtag.toLowerCase(); // 转换为小写用于比较
          if (!map.has(key)) {
            map.set(key, item);
          }
        });
        return Array.from(map.values());
      };
      this.selectedTagForm.vtag = mergeUniqueVTags(this.selectedTagForm.vtag, this.selectTag.vtag);
      this.selectedTagForm.vtag.map(item => {
        this.selectedTagForm.vtagNum += item.validPackage.length;
      });
      this.selectTag.vtag = [];
      this.showAddTagWindow = false;
    },
    // 删除已选中tag
    delTag(index) {
      this.selectedTagForm.vtag.splice(index, 1);
      this.selectedTagForm.vtagNum = 0;
      this.selectedTagForm.vtag.map(item => {
        this.selectedTagForm.vtagNum += item.validPackage.length;
      });
    },
    // 删除全部选中的tag
    deleteAllTag() {
      this.selectedTagForm.vtag = [];
      this.selectedTagForm.vtagType = '';
      this.selectedTagForm.vtagNum = 0;
    },
    // 打开查看vtag详情
    checkVtagDetail(item) {
      this.vtagDetail = item;

      console.log(this.vtagDetail, '===this.vtagDetail');
      this.showVtagDetail = true;
    }
  }
};
</script>

<style scoped>
.driver-container {
  display: flex;
  flex-wrap: wrap;
  gap: 10px;
  height: 500px;
  overflow-y: auto;
}

.driver-item {
  border: 1px solid #ccc;
  border-radius: 5px;
  padding: 10px;
  box-sizing: border-box;
}

.driver-item.full-width {
  flex: 1 1 100%;
}

.driver-item.half-width {
  flex: 1 1 calc(50% - 5px);
}
</style>
<style>
.appendTag .el-input-group__append {
  background-color: #409eff;
  color: #fff;
  border-color: #409eff;
}
</style>
